import { useMessages } from 'next-intl';
import { Button } from '../../components/Button';

type SignInBoxProps = {
  loading?: boolean;
  onSubmit?: () => void;
};

export function SignInBox({ loading, onSubmit }: SignInBoxProps) {
  return (
    <div className="max-sm:px-5 p-10 border border-medium-grey max-w-[480px] max-sm:w-full max-sm:mx-4">
      {loading ? <SignInBoxLoading /> : <SignInForm onSubmit={onSubmit} />}
    </div>
  );
}

function SignInForm({ onSubmit }: Pick<SignInBoxProps, 'onSubmit'>) {
  const labels = useMessages().loginPage;

  return (
    <form aria-label="signin">
      <h1 className="text-[18px] mb-2 uppercase border-b-2 border-light-grey pb-2 font-medium">
        {labels.login_popup_header}
      </h1>
      <p className="mb-5 text-sm">{labels.login_popup_message}</p>
      <Button className="uppercase w-full" onClick={() => onSubmit?.()}>
        {labels.login_button}
      </Button>
    </form>
  );
}

function SignInBoxLoading() {
  const labels = useMessages().loginPage;

  return (
    <h1 className="text-[18px] mb-2 uppercase border-b-2 border-light-grey pb-2 font-medium">
      {labels.login_progress}
    </h1>
  );
}
